import type { ISaleRepository, ReturnSaleInput } from '@/features/sale/domain/repositories/ISaleRepository.js';

export function createCancelSaleUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function cancelSaleUseCase(input: ReturnSaleInput): Promise<boolean> {
    return deps.saleRepository.cancelSale(input);
  };
}

export type CancelSaleUseCase = ReturnType<typeof createCancelSaleUseCase>;
